<ng-container *ngIf="!restrictedData">
    <app-barchart *ngIf="gridItem.type === widgetType.Barchart" [isInWizard]="isInWizard" [data]="data"
        [gridItem]="gridItem" [isCalls]="true" [type]="type" [colorSchemeId]="_colorSchemeId" [notifier]="notifier">
    </app-barchart>
    <app-linechart *ngIf="gridItem.type === widgetType.Linechart" [isInWizard]="isInWizard" [data]="data"
        [gridItem]="gridItem" [isCalls]="true" [type]="type" [colorSchemeId]="_colorSchemeId" [notifier]="notifier">
    </app-linechart>
    <app-areachart *ngIf="gridItem.type === widgetType.Areachart" [isInWizard]="isInWizard" [data]="data"
        [gridItem]="gridItem" [isCalls]="true" [type]="type" [colorSchemeId]="_colorSchemeId" [notifier]="notifier">
    </app-areachart>
</ng-container>
<div *ngIf="restrictedData" class="restricted-data">
    <div class="restricted-icon"><i class="fal fa-eye-slash"></i></div>
    <span class="restricted-title">{{ 'Access not allowed' | i18next }}</span>
    <span class="restricted-description">{{ "You don't have a permission to see the data" | i18next }}</span>
</div>